/** The Daily rolls over at 00:00 UK time (design.md B14.3). */
const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' });

export function ukDate(ms: number = Date.now()): string {
  return fmt.format(new Date(ms));
}

/** Milliseconds until the next UK midnight (handles BST/GMT). */
export function msToUkMidnight(ms: number = Date.now()): number {
  const today = ukDate(ms);
  // Step forward in 15-minute jumps, then minutes: cheap and DST-proof.
  let t = ms;
  while (ukDate(t + 15 * 60000) === today) t += 15 * 60000;
  while (ukDate(t + 60000) === today) t += 60000;
  // t is within the last minute of the day.
  const next = new Date(t + 60000);
  next.setUTCSeconds(0, 0);
  return Math.max(0, next.getTime() - ms);
}
